import { useGameStore } from '@/lib/stores/gameStore';
import { JournalEventList } from '@/components/panels/journal/JournalEventList';
import { ScrollText } from 'lucide-react';
import type { CampaignJournal } from '@danda/shared';

interface JournalTabContentProps {
  journal?: CampaignJournal | null;
}

function EmptyState() {
  return (
    <div className="flex-1 flex flex-col items-center justify-center gap-3 text-muted-foreground px-8">
      <ScrollText className="h-10 w-10 opacity-30" />
      <p className="font-narrative text-sm text-center italic">Your adventure journal awaits...</p>
      <p className="text-xs text-center opacity-60">
        Events will appear here as your story unfolds
      </p>
    </div>
  );
}

export function JournalTabContent({ journal: journalProp }: JournalTabContentProps) {
  const gameJournal = useGameStore((s) => s.campaignJournal);
  const journal = journalProp ?? gameJournal;

  if (!journal?.events?.length) return <EmptyState />;

  return <JournalEventList journal={journal} className="mx-6 mb-4" />;
}
